import { useState } from "react";

export interface ClaimAttestationProps {
  isCertified: boolean;
  onChangeCertified: (value: boolean) => void;
  signature: string;
  onChangeSignature: (value: string) => void;
}

const useClaimAttestation = (): ClaimAttestationProps => {
  const [isCertified, onChangeCertified] = useState(false);
  const [signature, onChangeSignature] = useState("");

  return {
    isCertified,
    onChangeCertified,
    signature,
    onChangeSignature,
  };
};

export default useClaimAttestation;
